import { InjectionToken } from '@angular/core';

export const BREADCRUMB_PROVIDERS = new InjectionToken<Record<string, unknown>[]>('Breadcrumb providers');
